<button #btn="shareButton"
        type="button"
        class="sb-wrapper"
        [class.sb-show-icon]="showIcon"
        [class.sb-show-text]="showText"
        [shareButton]="button"
        [url]="url"
        [image]="image"
        [title]="title"
        [description]="description"
        [tags]="tags"
        [redirectUrl]="redirectUrl"
        [autoSetMeta]="autoSetMeta"
        [disabled]="disabled"
        (opened)="opened.emit($event)"
        (closed)="closed.emit($event)">

  <div *ngIf="btn" class="sb-content">

    <div *ngIf="showIcon && btn.icon" class="sb-icon">
      <fa-icon [icon]="icon || btn.icon" [fixedWidth]="true"></fa-icon>
    </div>

    <div *ngIf="showText" class="sb-text">
      {{ text || btn.text }}
    </div>

  </div>
</button>
